interface ExportTableFootProps {
  page: number;
  pageSize: number;
  total: number;
  showing: number;
  hasMore: boolean;
  pageLoading?: boolean;
  onPageChange: (page: number) => void;
  compact?: boolean;
}

export function ExportTableFoot({
  page,
  pageSize,
  total,
  showing,
  hasMore,
  pageLoading = false,
  onPageChange,
  compact = false,
}: ExportTableFootProps) {
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = page * pageSize + showing;

  return (
    <div
      className={`table-foot invoice-cursor-pager flex flex-wrap items-center justify-between border-t border-[var(--border-soft)] bg-[var(--surface-2)] text-[var(--muted)] ${
        compact
          ? "invoice-cursor-pager--compact gap-2 px-3 py-1.5 text-xs"
          : "gap-2 px-4 py-2 text-xs"
      }`}
    >
      <span>
        Showing {from} to {to} of {total} entries
      </span>
      <div className="pager flex items-center gap-2">
        <button
          type="button"
          className="pager-nav-btn text-xs"
          disabled={page <= 0 || pageLoading}
          onClick={() => onPageChange(page - 1)}
        >
          ← Previous
        </button>
        <span className="tabular-nums font-semibold text-[var(--text)]">
          {page + 1}
        </span>
        <button
          type="button"
          className="pager-nav-btn text-xs"
          disabled={!hasMore || pageLoading}
          onClick={() => onPageChange(page + 1)}
        >
          Next →
        </button>
      </div>
    </div>
  );
}
